import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

import './shared/services/instrument'
import { ENV_PROPS } from './props'

if (environment.production) {
  enableProdMode()
}

console.log('Used env props', ENV_PROPS)

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()]
  })
  .catch(err => console.error(err))
